import { useEffect, useState } from "react";
import { NfSaidaService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
import { DashboardCard, DashboardChart } from "../../../main/components";

function RelatorioDashboardProdutosVendidos({
  filtrosAvancados,
  relatoriosDashborad,
  setRelatoriosDashborad,
}) {
  const [loading, setLoading] = useState(false);
  const nfSaidaService = new NfSaidaService();

  useEffect(() => {
    dashboardProdutosVendidos({
      ...filtrosAvancados,
      porIntervalo: [
        {
          ...filtrosAvancados.porIntervalo[0],
          coluna: "dataLancamento",
        },
      ],
    });
  }, [
    filtrosAvancados.porIntervalo[0].de,
    filtrosAvancados.porIntervalo[0].ate,
  ]);

  async function dashboardProdutosVendidos(body) {
    setLoading(true);
    const result = await nfSaidaService.getRelatorioDashboardProdutosVendidos(
      body
    );
    if (!result.isAxiosError) {
      setRelatoriosDashborad((prevValue) => ({
        ...prevValue,
        produtosVendidos: {
          categories: result.data.categories,
          series: [
            {
              name: "Produto",
              type: "bar",
              data: result.data.series,
              borderColor: null,
            },
          ],
        },
      }));
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  return (
    <DashboardCard
      title="Top 10 Produtos mais vendidos"
      chart={true}
      ActionIcon={
        <i
          className="ph-fill ph-package"
          style={{ color: "#494C62", fontSize: 22 }}
        ></i>
      }
    >
      <DashboardChart
        loading={loading}
        data={relatoriosDashborad.produtosVendidos}
        heightChart={"70%"}
        options={{
          legend: {
            enabled: false,
          },
          xAxis: {
            type: "category",
            labels: {
              formatter: function () {
                return `<span title="${this.value}">
                  ${
                    this.value.length > 20
                      ? this.value.substring(0, 20) + "..."
                      : this.value
                  }
                </span>`;
              },
              useHTML: true,
              style: {
                cursor: "pointer",
                zIndex: -2,
                fontSize: "12px",
              },
            },
            crosshair: true,
          },
          yAxis: {
            tickPixelInterval: 150,
            title: {
              text: null,
            },
            labels: {
              style: {
                fontSize: "12px",
              },
            },
            maxPadding: 0.2,
            endOnTick: true,
            alignTicks: true,
            overflow: "allow",
          },
          plotOptions: {
            series: {
              animation: false,
              groupPadding: 0,
              pointPadding: 0.1,
              borderWidth: 0,
              colorByPoint: true,
              dataSorting: {
                enabled: true,
                matchByName: true,
              },
              type: "bar",
              dataLabels: {
                style: {
                  color: "#666",
                  fontWeight: 600,
                  border: "none",
                },
                align: "left",
                enabled: true,
                formatter: function () {
                  return formatPrice(this.y);
                },
              },
            },
          },
          tooltip: {
            shared: true,
            useHTML: true,
            backgroundColor: "#fff",
            borderWidth: 0,
            borderRadius: 4,
            formatter: function () {
              return `
                <div style="padding: 3px">
                  <span style="font-size: 12px">${this.key}</span><br/>
                  <b>${formatPrice(this.points[0].y)}</b>
                </div>
              `;
            },
          },
        }}
      />
    </DashboardCard>
  );
}

export default RelatorioDashboardProdutosVendidos;
